import { useEffect, useState } from "react";
import { Switch } from "@/components/ui/switch";

const KEY = "electra-consent";

export const getConsent = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY));
  } catch {
    return null;
  }
};

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [manage, setManage] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    if (!getConsent()) setVisible(true);
    const reopen = () => {
      const c = getConsent();
      if (c) {
        setAnalytics(!!c.analytics);
        setMarketing(!!c.marketing);
      }
      setManage(true);
      setVisible(true);
    };
    window.addEventListener("electra:open-consent", reopen);
    return () => window.removeEventListener("electra:open-consent", reopen);
  }, []);

  const save = (a, m) => {
    localStorage.setItem(KEY, JSON.stringify({ necessary: true, analytics: a, marketing: m, at: new Date().toISOString() }));
    window.dispatchEvent(new CustomEvent("electra:consent", { detail: { analytics: a, marketing: m } }));
    setVisible(false);
    setManage(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-banner" role="dialog" aria-label="Cookie consent" className="fixed bottom-0 inset-x-0 z-[60] p-4 sm:p-6">
      <div className="mx-auto max-w-3xl border-2 border-ink bg-paper p-6 shadow-[8px_8px_0_0_#0A0E17]">
        <p className="eyebrow text-ink/50">Cookies, honestly</p>
        <p className="mt-2 text-sm leading-relaxed text-ink/80">
          We use essential cookies to run the site. Analytics and marketing cookies are off unless you switch them on,
          and nothing non-essential fires before you say yes.
        </p>
        {manage && (
          <div className="mt-4 space-y-3 border-t border-ink/10 pt-4">
            <label className="flex items-center justify-between gap-4 text-sm font-medium">
              Essential <span className="font-mono text-xs text-ink/40">always on</span>
            </label>
            <label className="flex items-center justify-between gap-4 text-sm font-medium" htmlFor="consent-analytics">
              Analytics
              <Switch id="consent-analytics" data-testid="cookie-toggle-analytics" checked={analytics} onCheckedChange={setAnalytics} />
            </label>
            <label className="flex items-center justify-between gap-4 text-sm font-medium" htmlFor="consent-marketing">
              Marketing
              <Switch id="consent-marketing" data-testid="cookie-toggle-marketing" checked={marketing} onCheckedChange={setMarketing} />
            </label>
          </div>
        )}
        <div className="mt-5 flex flex-wrap gap-3">
          <button
            data-testid="cookie-accept-button"
            onClick={() => save(true, true)}
            className="bg-ink px-5 py-2.5 text-sm font-bold text-paper transition-transform duration-300 hover:-translate-y-0.5"
          >
            Accept all
          </button>
          <button
            data-testid="cookie-reject-button"
            onClick={() => save(false, false)}
            className="border-2 border-ink px-5 py-2.5 text-sm font-bold text-ink transition-colors hover:bg-ink hover:text-paper"
          >
            Reject all
          </button>
          {manage ? (
            <button
              data-testid="cookie-save-button"
              onClick={() => save(analytics, marketing)}
              className="bg-pink px-5 py-2.5 text-sm font-bold text-ink transition-transform duration-300 hover:-translate-y-0.5"
            >
              Save choices
            </button>
          ) : (
            <button
              data-testid="cookie-manage-button"
              onClick={() => setManage(true)}
              className="px-5 py-2.5 text-sm font-bold text-ink underline underline-offset-4 hover:text-ink/60"
            >
              Manage
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
